import { createContext, useContext, useState, useCallback, useRef } from 'react';
import { useNotifications } from './NotificationContext';

const VacancyContext = createContext(null);

const SEEN_KEY   = 'pg_seen_vacancy_ids';
const UNREAD_KEY = 'pg_unread_vacancies';

function loadSeen() {
  try { return new Set(JSON.parse(localStorage.getItem(SEEN_KEY) ?? '[]')); }
  catch { return new Set(); }
}
function saveSeen(set) {
  try { localStorage.setItem(SEEN_KEY, JSON.stringify([...set])); } catch {}
}

export function VacancyProvider({ children }) {
  const [vacancies, setVacancies] = useState([]);
  const [unreadCount, setUnread]  = useState(() =>
    parseInt(localStorage.getItem(UNREAD_KEY) ?? '0', 10)
  );

  const seenIds  = useRef(loadSeen());
  const { push } = useNotifications();

  // Called by Vacancies.js after it fetches from Monday API
  const syncVacancies = useCallback((data) => {
    setVacancies(data);

    const newItems = data.filter(v => !seenIds.current.has(v.id));
    newItems.forEach(v => {
      seenIds.current.add(v.id);
      push({
        mondayId: v.id,
        type:  'vacancy',
        title: v.title,
        body:  v.description?.slice(0, 80) + (v.description?.length > 80 ? '…' : ''),
        link:  '/Vacancies',
      });
    });

    if (newItems.length > 0) {
      saveSeen(seenIds.current);
      setUnread(prev => {
        const next = prev + newItems.length;
        localStorage.setItem(UNREAD_KEY, String(next));
        return next;
      });
    }
  }, [push]);

  const clearUnread = useCallback(() => {
    setUnread(0);
    localStorage.setItem(UNREAD_KEY, '0');
  }, []);

  return (
    <VacancyContext.Provider value={{ vacancies, unreadCount, clearUnread, syncVacancies }}>
      {children}
    </VacancyContext.Provider>
  );
}

export const useVacancies = () => useContext(VacancyContext);